import { Component, OnInit } from '@angular/core';
import { ShopService } from '../../../configuration/services/shop.service';
import { CashMovementService } from '../../services/cash-movement.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-view-cash-movement',
  templateUrl: './view-cash-movement.component.html',
  styleUrls: ['./view-cash-movement.component.css'],
  providers: [ShopService,CashMovementService]
})
export class ViewCashMovementComponent implements OnInit {
    id: number = undefined;
    private sub: any;
    cashMovement: any = {};
    shops: any = [];
    type: number;
    shopId: number;


  constructor(private route: ActivatedRoute, private router: Router, private shopService:ShopService, private cashMovementService:CashMovementService) { 
    this.getShops().then(()=>{
        this.sub = this.route.params.subscribe(params => {
            if (params['id'] !== undefined){
                this.id = params['id'];
                this.getCashMovement();
            }
        });
        this.shopId = parseInt(localStorage.getItem('shop'));
    });
  }

  ngOnInit() {
  }

  assignShop(){
    if (this.type === 1){
      this.cashMovement.to_shop = this.shopId;
      this.cashMovement.from_shop = null;
    }else if (this.type == 2){
      this.cashMovement.from_shop = this.shopId;
      this.cashMovement.to_shop = null;
    }
  }

  getShops(){
    return new Promise((resolve, reject) => {
        this.shopService.query({})
        .subscribe((shops) => {
            this.shops = shops;
            this.shops.push({id:0, name:"Banco"})
            resolve();
        });
    });
  }


  getCashMovement(){
    this.cashMovementService.get(this.id).subscribe((cashMovement) => {
        this.cashMovement = cashMovement;
        this.cashMovement.from_shop = cashMovement.from_shop? cashMovement.from_shop.id:0;
        this.cashMovement.to_shop = cashMovement.to_shop? cashMovement.to_shop.id:0;
        this.type = parseInt(cashMovement.type);
    });
  }

  saveExpense(){
    if (!this.cashMovement.id){
        this.cashMovementService.create(this.returnProperties(this.cashMovement)).subscribe((cashMovement) =>{
            this.cashMovement = cashMovement;
            this.router.navigate(["/tpv"]); 
        });
    }else{
        this.cashMovementService.update(this.returnProperties(this.cashMovement)).subscribe((cashMovement) =>{
            this.cashMovement = cashMovement;
        });
    }
  }

  returnProperties(cashMovement){
    var properties = {
        type: this.type,
        to_shop: cashMovement.to_shop,
        from_shop: cashMovement.from_shop,
        amount: cashMovement.amount,
    }
    if (cashMovement.id){
      properties['id'] = cashMovement.id;
    }
    return properties;
  }

  
}


// WEBPACK FOOTER //
// ./src/app/cashmovements/components/view-cash-movement/view-cash-movement.component.ts